/**
 * Cursor style utilities for canvas tools
 * Extracted from Canvas.jsx to reduce file size
 */

/**
 * Get appropriate cursor style for each tool
 * @param {string} action - The current canvas action/tool
 * @returns {string} CSS cursor value
 */
export const getCursorStyle = (action) => {
  switch (action) {
    case "PAN":
      return "grab";
    case "RECTANGLE":
      return "crosshair";
    case "CIRCLE":
      return "crosshair";
    case "ARROW":
      return "crosshair";
    case "SCRIBBLE":
      return "crosshair";
    case "LINE":
    case "line":
      return "crosshair";
    case "IMAGE":
      return "crosshair";
    case "TEXT":
      return "crosshair";
    default:
      return "default";
  }
};
